"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = cloneContent;

var _reduce = _interopRequireDefault(require("lodash/reduce"));

var _omit = _interopRequireDefault(require("lodash/omit"));

var _generateUuid = _interopRequireDefault(require("./generate-uuid"));

function cleanAttrs() {
  var attrs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return (0, _omit["default"])(attrs, ["disableDelete"]);
}

function cloneContent(content) {
  return (0, _reduce["default"])(content, function (newContents, item) {
    newContents.push({
      id: (0, _generateUuid["default"])(),
      type: item.type,
      attrs: cleanAttrs(item.attrs),
      content: item.content && item.content.length > 0 ? cloneContent(item.content) : []
    });
    return newContents;
  }, []);
}